export const KNOWLEDGE_SUGGESTION_TABS = ["ready", "noEvidence"] as const
export type KnowledgeSuggestionTab = (typeof KNOWLEDGE_SUGGESTION_TABS)[number]
